<!-- Upcoming / In Progress / Overdue / Submitted / Evaluated -->
<div
  [ngClass]="getAssignmentStatusInfo(assignment, 'status-class')"
  [matTooltip]="getAssignmentStatusInfo(assignment, 'status-tooltip')"
  >
  @if (
    assignment?.status === 'pending' &&
    assignment?.dueStatus !== 'overdue' &&
    !checkIfInProgress(assignment)
    ) {
    <mat-icon
      aria-label="Assignment has not been Submitted"
      svgIcon="calendar-lines"
    ></mat-icon>
  }

  <!-- Overdue -->
  @if (assignment?.dueStatus === 'overdue' && !assignment?.evaluatedAt) {
    <mat-icon
      aria-label="Assignment is Overdue"
      svgIcon="alarm-icon"
    ></mat-icon>
  }

  <!-- In Progress -->
  @if (
    checkIfInProgress(assignment) &&
    assignment?.dueStatus !== 'overdue' &&
    !assignment?.evaluatedAt
    ) {
    <mat-icon
      aria-label="Assignment is in Progress"
      >location_on</mat-icon
      >
    }

    <!-- Submitted -->
    @if (assignment?.completedAt && !assignment?.evaluatedAt) {
      <mat-icon
        aria-label="Assignment has been Submitted"
        >check_circle_outline</mat-icon
        >
      }

      <!-- Evaluated -->
      @if (assignment?.evaluatedAt) {
        <mat-icon
          aria-label="Assignment has been Evaluated"
          >check_circle</mat-icon
          >
        }
      </div>
